/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { Typography2 } from '@coursera/cds-core';

import BadgePlaceholder from 'images/enterprise-learning-path-description-page/badge-placeholder.jpg';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  item: css`
    display: flex;
    gap: var(--cds-spacing-200);
  `,
  iconContainer: css`
    border-radius: 8px;
    background: var(--cds-color-neutral-background-primary-weak);
    display: flex;
    width: 76px;
    height: 54px;
    padding: calc(var(--cds-spacing-100) / 2);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  `,
  title: css`
    margin-bottom: var(--cds-spacing-50);
  `,
  description: css`
    max-width: 608px;
  `,
};

const CareerCertificateItem = () => {
  return (
    <div css={styles.item}>
      <div css={styles.iconContainer}>
        <Imgix src={BadgePlaceholder} alt={_t('Skill path badge')} height={55} />
      </div>
      <div>
        <Typography2 component="h3" variant="subtitleMedium" css={styles.title}>
          {_t('Earn a certificate')}
        </Typography2>
        <Typography2 component="p" variant="bodySecondary" css={styles.description}>
          {_t(
            'Complete the assessments in each section to verify your mastery and earn a certificate. Showcase your accomplishment by adding it to your resume or LinkedIn profile!'
          )}
        </Typography2>
      </div>
    </div>
  );
};

export default CareerCertificateItem;
